export default function CategoryCard({ category, onClick, venueType }) {
  return (
    <div onClick={() => {
      onClick(category)
    }} className={`w-full cursor-pointer duration-75 h-full flex flex-col items-center justify-center rounded-xl ${venueType === category ? "bg-app-secondary" : "bg-app-primary hover:bg-app-secondary"}`}>
      <p className="text-3xl text-white font-bold">{category}</p>
    </div>
  )
}
